import FJLocalStore from '../../../store/FJLocalStore';
import FJVerticalScroller from '../../../common/components/FJScroller/FJVerticalScroller';
import styles from './FJSceneTextList.module.less';
import PropTypes from 'prop-types';
import { useRef, useEffect, useCallback, useState } from 'react';
import FlipList from '../../../core/FJFlipList';
import FJSceneTextItem from '../FJSceneTextItem/FJSceneTextItem';
import FJUtil from '../../../util/FJUtil';
import { FJ_EVENT_TYPE } from '../../../constants/FJEvenTypeConstant';
import { useLayoutEffect } from 'react';
import FJEvent from '../../../store/FJEvent';
const SCENE_MARGIN = 10;
const TRANSFORM_OFFSET = 1;
const DRAG_ANIMATION_DURATION = 120;
const SCROLL_RANGE = 50;
const SCROLL_SPEED = 20;
let _scrollTimer = null;
let _preScrollTop = 0;
const FJSceneTextList = props => {
    const { sceneTextList, updateSceneTextList, isShowHeader } = props;
    const [stateDragId, setStateDragId] = useState(null);
    const [stateIsDragging, setStateIsDragging] = useState(false);
    const [stateIsScrollUp, setStateIsScrollUp] = useState(false);
    const [stateMouseMoveIndex, setStateMouseMoveIndex] = useState(-1);
    const [stateIsScroll, setStateIsScroll] = useState(false);
    const draggingItemRef = useRef(null);
    const flipListRef = useRef(FlipList);
    const scrollRef = useRef(null);

    useEffect(() => {
        createNewFlipList(stateDragId);
    }, []);
    useLayoutEffect(() => {
        if (stateDragId && stateIsScroll) {
            let scroll = scrollRef.current.getScroller();
            _scrollTimer = setInterval(() => {
                let scrollTop = scroll.scrollTop + (stateIsScrollUp ? -SCROLL_SPEED : SCROLL_SPEED);
                scrollRef.current.scrollTop(scrollTop);
            }, 16.6);
        } else {
            clearInterval(_scrollTimer);
        }
        return () => {
            clearInterval(_scrollTimer);
        };
    }, [stateIsScroll, stateIsScrollUp, stateDragId]);
    useEffect(() => {
        const un = FJEvent.subscribe(FJ_EVENT_TYPE.SCROLL_SCENE_TO_END, () => {
            scrollRef.current && scrollRef.current.scrollToBottom();
        });
        return () => {
            un();
        };
    }, [stateDragId]);

    const updateScroll = e => {
        const point = FJUtil.calcCursorPoint(e);
        const scroll = scrollRef.current.getScroller();
        const scrollRect = scroll.getBoundingClientRect();
        if (point.y - scrollRect.top < SCROLL_RANGE) {
            setStateIsScroll(true);
            setStateIsScrollUp(true);
        } else if (scrollRect.bottom - point.y < SCROLL_RANGE) {
            setStateIsScroll(true);
            setStateIsScrollUp(false);
        } else {
            setStateIsScroll(false);
        }
    };

    const onDrag = (e, type, options) => {
        const { dragId } = options;
        const point = FJUtil.calcCursorPoint(e);
        _updateDraggingItemPosition(point, type);
        if (type === 'start') {
            setStateDragId(dragId);
            setStateIsDragging(true);
        } else if (type === 'change') {
            updateMouseMoveSceneIndex(e);
            updateScroll(e);
            createNewFlipList(dragId);
        } else if (type === 'end') {
            setStateDragId('');
            setStateIsDragging(false);
            updateSceneTextList(dragId, { type: FJ_EVENT_TYPE.MOVE, moveInsertIndex: stateMouseMoveIndex });
            setStateMouseMoveIndex(-1);

            _preScrollTop = scrollRef.current.getScroller().scrollTop;
        }
    };
    /**
     * @desc 记录children位置数据
     * @param {*} id
     * @returns
     */
    const createNewFlipList = id => {
        if (!scrollRef.current.getScroller()) return;
        //记录动画
        const parentNode = scrollRef.current.getScroller();
        const children = Array.from(parentNode.children);
        const dragIndex = sceneTextList.findIndex(item => item.id === id);
        const dragItem = children[dragIndex];
        const listenChildren = [...scrollRef.current.getScroller().children].filter(k => k !== dragItem);
        //列表
        flipListRef.current = new FlipList(listenChildren, DRAG_ANIMATION_DURATION, null, 0);
        flipListRef.current.recordFirst();
    };
    const __playAnimation = () => {
        if (!scrollRef.current) return;
        scrollRef.current.scrollTop(_preScrollTop);
        //列表动画
        flipListRef.current?.play(() => flipListRef.current?.recordFirst());
        //拖拽元素动画
    };
    //拖动动画效果
    useEffect(() => {
        return () => {
            stateDragId && __playAnimation();
        };
    }, [stateDragId]);
    //增删场景位移动画效果
    useEffect(() => {
        createNewFlipList();
        return () => {
            flipListRef.current?.play(() => flipListRef.current?.recordFirst());
        };
    }, [sceneTextList.length]);
    //更新当前拖动的位置
    const updateMouseMoveSceneIndex = e => {
        if (!scrollRef.current) return;
        const point = FJUtil.calcCursorPoint(e);
        let index = sceneTextList.findIndex(item => item.id === stateDragId);
        for (let i = 0; i < sceneTextList.length; i++) {
            const itemDom = document.getElementById(`scene-text-item-${i}`);
            if (!itemDom) {
                return;
            }
            const itemRect = itemDom.getBoundingClientRect();

            if (point.y >= itemRect.top - SCENE_MARGIN / 2 && point.y <= itemRect.bottom + SCENE_MARGIN / 2) {
                if (point.y >= (itemRect.top + itemRect.bottom) / 2) index = i + 1;
                else index = i;
                break;
            }
        }

        setStateMouseMoveIndex(index);
    };
    //更新拖拽元素位置
    const _updateDraggingItemPosition = ({ x, y }, type) => {
        if (!draggingItemRef.current) return;
        const HEIGHT = 42;
        if (type === 'start') {
            draggingItemRef.current.style.opacity = 1;
            draggingItemRef.current.style.visibility = 'visible';
            draggingItemRef.current.style.transform = `translate(${x}px, ${y - HEIGHT / 2}px)`;
            document.body.style.cursor = 'grabbing !important';
        } else if (type === 'change') {
            draggingItemRef.current.style.transform = `translate(${x}px, ${y - HEIGHT / 2}px)`;
        } else if (type === 'end') {
            document.body.style.cursor = '';
            draggingItemRef.current.style.opacity = 0;
            draggingItemRef.current.style.visibility = 'hidden';
        }
    };
    // 拖拽元素
    const _renderDraggingItem = () => {
        const item = sceneTextList.find(item => item.id === stateDragId);
        const index = sceneTextList.findIndex(item => item.id === stateDragId);
        return (
            <div className={styles.dragging_item} ref={draggingItemRef}>
                <div className={styles.dragging_item_title}>{FJLocalStore._('scene') + ' ' + (index + 1)}</div>
                <div className={styles.dragging_item_content}>{item?.text}</div>
            </div>
        );
    };
    //scene上下偏移
    const dragItemStyle = useCallback(
        (item, index) => {
            let style = {};
            if (index === stateMouseMoveIndex - 1 && sceneTextList[index].id !== stateDragId) {
                style.transform = `translateY(${-TRANSFORM_OFFSET}px)`;
            } else if (index === stateMouseMoveIndex && sceneTextList[index].id !== stateDragId) {
                style.transform = `translateY(${TRANSFORM_OFFSET}px)`;
            }
            return style;
        },
        [stateMouseMoveIndex, stateDragId, sceneTextList],
    );
    const _onScroll = () => {
        // 滚动后位置需要重新记录
        createNewFlipList();
    };

    const dragIndex = sceneTextList.findIndex(i => i.id === stateDragId);
    return (
        <div className={styles.edit_container}>
            {isShowHeader && (
                <div className={styles.header}>
                    <div className={styles.header_title}>{FJLocalStore._('ai-summary')}</div>
                </div>
            )}
            <FJVerticalScroller className={styles.content} ref={scrollRef} onScroll={_onScroll}>
                {sceneTextList.map((item, index) => (
                    <div key={item.id}>
                        {index === 0 ? (
                            <div
                                className={styles.drag_line}
                                style={{ opacity: stateMouseMoveIndex === 0 ? 1 : 0 }}
                            ></div>
                        ) : null}
                        <FJSceneTextItem
                            key={item.id}
                            item={item}
                            index={index}
                            onDrag={onDrag}
                            dragId={stateDragId}
                            isDragging={stateIsDragging}
                            style={dragItemStyle(item, index)}
                            updateSceneTextList={updateSceneTextList}
                        />
                        <div
                            className={styles.drag_line}
                            style={{
                                opacity:
                                    index === stateMouseMoveIndex - 1 &&
                                    dragIndex !== stateMouseMoveIndex &&
                                    dragIndex !== stateMouseMoveIndex - 1
                                        ? 1
                                        : 0,
                            }}
                        />
                    </div>
                ))}
            </FJVerticalScroller>
            {_renderDraggingItem()}
        </div>
    );
};

FJSceneTextList.propTypes = {
    sceneTextList: PropTypes.array,
    updateSceneTextList: PropTypes.func,
    isShowHeader: PropTypes.bool,
};

export default FJSceneTextList;
